<script setup>
import Hero from '../components/index/Hero.vue'
import CashPrizes from '../components/index/CashPrizes.vue'
import WaysToPlay from '../components/index/WaysToPlay.vue'
import Schedule from '../components/index/Schedule.vue'
import Prizing from '../components/index/Prizing.vue'
import AdaptiveGamingKit from '../components/index/AdaptiveGamingKit.vue'
import Partners from '../components/index/Partners.vue'
</script>

<template>
	<Hero />
	<CashPrizes />
	<WaysToPlay />
	<!-- <Schedule /> -->
	<Prizing />
	<AdaptiveGamingKit />
	<Partners />
</template>
